<div class="swiper-container" [swiper]="config" *ngIf="items">
  <div class="swiper-wrapper">
    <div class="swiper-slide" *ngFor="let item of items; let isFirst = first">
      <div class="d-flex w-100 gallery-item position-relative">
        <img style="object-fit: cover" class="img-fluid w-100" [src]="item.file.path" alt="Elsa">
        <div class="box-gradient"></div>
        <div class="box-info">
          <div class="container">
            <div class="row">
              <div class="col-60 col-lg-33">
                <div class="d-flex flex-column w-100 text-white">
                  <h5 class="text-uppercase elsa-title-font gallery-item-subtitle my-2">{{item.title_super}}</h5>
                  <div class="gallery-item-border"></div>
                  <ng-container *ngIf="isFirst; else elseCondition">
                    <h2 class="text-uppercase elsa-title-font gallery-item-title">{{item.title}}</h2>
                  </ng-container>
                  <ng-template #elseCondition>
                    <h3 class="text-uppercase elsa-title-font gallery-item-title">{{item.title}}</h3>
                  </ng-template>
                  <p class="gallery-item-description">{{item.description}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="swiper-pagination gallery-pagination"></div>
</div>
